import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import useDivvyUUID from '@sputnik/hooks/useDivvyUUID'
import { GetCreditApplicationDetails_creditApplication_CreditApplication } from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/GetCreditApplicationDetails.gql'

import AwaitingSignatureBanner from './AwaitingSignatureBanner'
import ConfirmIdentityBanner from './ConfirmIdentityBanner'
import CorrectionNeededBanner from './CorrectionNeededBanner'
import FrozenCreditBanner from './FrozenCreditBanner'
import { useGetFrozenAuthorizedSigner } from './GetFrozenAuthorizedSigner.gql'
import OfferAcceptedBanner from './OfferAcceptedBanner'
import OfferReadyBanner from './OfferReadyBanner'
import RefreshApplicationBanner from './RefreshApplicationBanner'
import ResumeApplicationBanner from './ResumeApplicationBanner'
import ReviewMigrationBanner from './ReviewMigrationBanner'
import styles from './styles.module.scss'
import UploadDocumentsBanner from './UploadDocumentsBanner'

interface ActionsNeededSectionProps {
  creditApplication: GetCreditApplicationDetails_creditApplication_CreditApplication
  setActiveTabToDocuments: () => void
}

const ActionsNeededSection = ({ creditApplication, setActiveTabToDocuments }: ActionsNeededSectionProps) => {
  const [getClassName] = useNameFormatter('ActionsNeededSection')

  const { salesforceCreditId, personaInquiries, dsaVersion, authorizedSigner } = creditApplication || {}
  const authSignerEmail = authorizedSigner?.email || ''

  const [companyDivvyUuid] = useDivvyUUID()
  const { data } = useGetFrozenAuthorizedSigner({
    variables: {
      companyId: companyDivvyUuid || '',
    },
    skip: !companyDivvyUuid,
  })

  return (
    <div className={styles[getClassName('banners-container')]}>
      {/* COM-9462: add conditions for showing each banner when we have it from backend. */}
      <UploadDocumentsBanner setActiveTabToDocuments={setActiveTabToDocuments} />
      <RefreshApplicationBanner salesforceCreditId={salesforceCreditId} />
      <ResumeApplicationBanner salesforceCreditId={salesforceCreditId} />
      <OfferReadyBanner
        authorizedSignerEmail={authSignerEmail}
        salesforceCreditId={salesforceCreditId}
      />
      <AwaitingSignatureBanner salesforceCreditId={salesforceCreditId} />
      <ReviewMigrationBanner
        dsaVersion={dsaVersion}
        salesforceCreditId={salesforceCreditId}
      />
      <CorrectionNeededBanner salesforceCreditId={salesforceCreditId} />
      {personaInquiries && personaInquiries.length > 0 && (
        <ConfirmIdentityBanner
          personaInquiries={personaInquiries}
          salesforceCreditId={salesforceCreditId}
        />
      )}

      {!!data?.frozenAuthorizedSigner && (
        <FrozenCreditBanner
          authSignerEmail={authSignerEmail}
          salesforceCreditId={salesforceCreditId}
        />
      )}

      {/* For authorized signer only: */}
      <OfferAcceptedBanner />
    </div>
  )
}

export default ActionsNeededSection
